import {apiClient} from "../../connection/BlinkApiClient.js";
import {loadVersionedObjectFromResponse} from "../misc/StoreUtils";
import {toArray} from "../../../stem-core/base/Utils.js";
import {BaseStore, globalStore} from "../../../stem-core/state/Store.js";
import {MerchantSDKResource} from "../misc/MerchantSDKResource.js";
import {MerchantPanel} from "./MerchantPanelStore";

interface EditUserJourneyRequest {
    userJourneyId: number;
    [key: string]: any;
}


@globalStore
export class MerchantUserJourney extends BaseStore("MerchantUserJourney", {dependencies: ["MerchantPanel"]}, MerchantSDKResource) {
    getActions(): any[] {
        return toArray(this.options?.action);
    }

    usesPanel(panel: MerchantPanel): boolean {
        for (const action of this.getActions()) {
            if (action.panel == panel.id || action.panel == panel.alias) {
                return true;
            }
        }
        return false;
    }
}

export async function apiCreateMerchantUserJourney(data: any): Promise<MerchantUserJourney> {
    const response = await apiClient.post("/merchant/create_user_journey", data);
    return loadVersionedObjectFromResponse(MerchantUserJourney, response, null);
}

export async function apiEditMerchantUserJourney(data: EditUserJourneyRequest): Promise<MerchantUserJourney> {
    const response = await apiClient.post("/merchant/edit_user_journey", data);
    return loadVersionedObjectFromResponse(MerchantUserJourney, response, data.userJourneyId);
}

export async function apiDeleteMerchantUserJourney(data: any): Promise<any> {
    return apiClient.post("/merchant/delete_user_journey", data);
}
